import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { AppSettings } from "../settings/app.settings";
import { StringExtensions } from "../utilities/string.extensions";
import { AppRoutes } from "../settings/routes";
import { Location } from "../utilities/location";
import { SampleBlendService } from "../ui/pages/subsample/subsample-blend/sampleblend.service";



@Component({
    selector: "fezaredirector",
    template: `
    <div class="row">
		<div class="col-sm-6">

			<p class="font-size-xs text light margin-bottom-sm">
				To check the feasibility on your subsamples and build the blend, please use the detour below:
			</p>

           <div *ngIf="errors" class="alert alert-danger margin-bottom-sm" [innerHTML]="errors | replaceLineBreak"></div>
			<a class="btn btn-default"  [class.disabled]="isBusy" target="_blank" (click)="redirectToFeza()" data-autmoation-continue-in-feza-button><i class="fas fa-external-link-alt" aria-hidden="true"></i> Feasibility results</a>
			<br><br>
		</div><!-- col -->
	</div>
`, styles: ["a.active { color: #8e7ab8; }"]
})
export class FezaRedirectorComponent implements OnInit, OnDestroy {
    @Input() eventId: number = -1;
    redirectorPath: string = "";
    isBusy: boolean = false;
    errors: string = "";
  
    constructor(
      private appSettings: AppSettings,
      private router: Router,
      private sampleBlendService: SampleBlendService,
    ) { }

  ngOnInit() {
    
    }

    private initRedirectPath(eventId: number, bidId:string) {
        this.redirectorPath = StringExtensions.formatByName(this.appSettings.FezaPath, {
          "eventId": eventId,
          "bidId": bidId
        });
    }
    redirectToFeza() {
      if (this.eventId > 0) {
        this.isBusy = true;
        this.errors = "";
        this.sampleBlendService.getManualFeasibility(this.eventId, StringExtensions.generateUUID(), "", "", false).subscribe(response => { // added the made up params
          this.isBusy = false;                                                                                                            // because this component is not used for the moment
          this.initRedirectPath(this.eventId, response.request.bidId);
          let args = StringExtensions.jsonQueryString({ "FezaRedirectUrl": Location.encode(this.redirectorPath) })
          let url = `//${Location.host}/#/${AppRoutes.detour.path}/${AppRoutes.detour.feza.path}?` + args;
          window.open(url);
        },
          error => {
            this.isBusy = false;
            this.errors = error.message;
          });
        }
        else {
            this.router.navigate([AppRoutes.redirectError.path]);
        }
    }

    ngOnDestroy() {
    }
}
